import React from "react";

interface ErrorMessageProps {
  id: string;
  message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ id, message }) => (
  <p id={id} className="bg-red-100 text-red-700 border border-red-300 p-4 my-2.5 rounded text-sm font-bold text-center w-[290px]">
    {message}
  </p>
);

export default ErrorMessage;
